import ModuleContent from 'components/ModuleContent';
import { WebFrameContent } from 'components/WebFrameContent/WebFrameContent';
import { Route, Switch } from 'react-router-dom';
import { ROUTE_FRAME } from 'utils/routes';

export const MainContent = () => {
  return (
    <Switch>
      <Route exact path={ROUTE_FRAME} component={WebFrameContent} />
      <Route component={ModuleContent} />
    </Switch>
  );
};
